import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Generic "recent N items" panel — used for both Referrals and Messages on the
 * Admin Overview page. Render-children pattern keeps row layout flexible.
 */
export default function RecentList({ title, viewAllHref, viewAllTestId, testid, items, emptyMessage, renderItem }) {
    return (
        <section className="bg-white rounded-2xl border border-[#E5DFD3] p-6" data-testid={testid}>
            <div className="flex items-center justify-between mb-4">
                <h2 className="font-[Outfit] text-[18px] font-semibold tracking-tight">{title}</h2>
                <Link
                    to={viewAllHref}
                    className="text-[12.5px] text-[#0E2A47] hover:underline inline-flex items-center gap-1"
                    data-testid={viewAllTestId}
                >
                    View all <ArrowUpRight className="h-3 w-3" />
                </Link>
            </div>
            {items.length === 0 ? (
                <p className="text-[14px] text-[#6F6B63]">{emptyMessage}</p>
            ) : (
                <ul className="space-y-3">
                    {items.map((item) => (
                        <li
                            key={item.id}
                            className="flex items-start justify-between gap-3 border-b border-[#E5DFD3] pb-3 last:border-0 last:pb-0"
                        >
                            {renderItem(item)}
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}
